import { Spinner as RadixSpinner } from '@radix-ui/themes';
import { withMappingProps } from '../../utils/radix.js';
export const Spinner = withMappingProps(RadixSpinner);
//# sourceMappingURL=spinner.js.map